import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProductDetailPage = lazy(() => import('../pages/product-detail/page'));
const CartPage = lazy(() => import('../pages/cart/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const KampanyalarPage = lazy(() => import('../pages/kampanyalar/page'));
const HakkimizdaPage = lazy(() => import('../pages/hakkimizda/page'));
const TariflerPage = lazy(() => import('../pages/tarifler/page'));
const UrunlerPage = lazy(() => import('../pages/urunler/page'));
const SSSPage = lazy(() => import('../pages/sss/page'));
const KargoPage = lazy(() => import('../pages/kargo/page'));
const IadePage = lazy(() => import('../pages/iade/page'));
const GizlilikPage = lazy(() => import('../pages/gizlilik/page'));
const KullanimKosullariPage = lazy(() => import('../pages/kullanim-kosullari/page'));
const CerezPage = lazy(() => import('../pages/cerez/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/urunler',
    element: <UrunlerPage />,
  },
  {
    path: '/urun/:id',
    element: <ProductDetailPage />,
  },
  {
    path: '/sepet',
    element: <CartPage />,
  },
  {
    path: '/odeme',
    element: <CheckoutPage />,
  },
  {
    path: '/iletisim',
    element: <ContactPage />,
  },
  {
    path: '/kampanyalar',
    element: <KampanyalarPage />,
  },
  {
    path: '/hakkimizda',
    element: <HakkimizdaPage />,
  },
  {
    path: '/tarifler',
    element: <TariflerPage />,
  },
  {
    path: '/sss',
    element: <SSSPage />,
  },
  {
    path: '/kargo',
    element: <KargoPage />,
  },
  {
    path: '/iade',
    element: <IadePage />,
  },
  {
    path: '/gizlilik',
    element: <GizlilikPage />,
  },
  {
    path: '/kullanim-kosullari',
    element: <KullanimKosullariPage />,
  },
  {
    path: '/cerez',
    element: <CerezPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;